<template>
  <div class="report-filter" :class="[getFilterOption.class]">
    <label class="report-filter__label">{{filter.label}}</label>
    <component
      class="report-filter__control"
      :is="getFilterOption.component"
      v-model="localModel"
      :items="filter.values"
      v-bind="getFilterOption.props"
    />
  </div>
</template>

<script>
import BaseDatepicker from '@components/common/BaseDatePicker.vue'
import BaseInput from '@components/common/BaseInput.vue'
import BaseTimePicker from '@components/common/BaseTimePicker.vue'
import BaseSelect from '@components/common/BaseSelect.vue'
import BaseRadioGroup from '@components/common/BaseRadioGroup.vue'
import BaseMapCircle from '@components/common/BaseMapCircle.vue'

const FILTER_TEXT = 'text'
const FILTER_NUMBER = 'number'
const FILTER_RADIO = 'radio'
const FILTER_SELECT = 'list'
const FILTER_MULTISELECT = 'multiselect'
const FILTER_TIME = 'time'
const FILTER_DATE = 'date'
const FILTER_CIRCLE = 'area'

const FILTER_OPTIONS = {
  [FILTER_TEXT]: { component: 'BaseInput' },
  [FILTER_NUMBER]: { component: 'BaseInput', props: { type: 'number'} },
  [FILTER_RADIO]: { component: 'BaseRadioGroup' },
  [FILTER_SELECT]: { component: 'BaseSelect' },
  [FILTER_MULTISELECT]: { component: 'BaseSelect', props: { multiple: true } },
  [FILTER_TIME]: { component: 'BaseTimePicker', props: { format: "hh:mm A", valueFormat : "HH:mm" }  },
  [FILTER_DATE]: { component: 'BaseDatepicker', props: { masks: { input: ['MM-DD-YYYY']} } },
  [FILTER_CIRCLE]: {
    component: 'BaseMapCircle',
    props: { editable: true },
    class: 'report-filter__map'
  },
}

export default {
  name: 'ReportFilter',
  components: { BaseDatepicker, BaseInput, BaseTimePicker, BaseSelect, BaseRadioGroup, BaseMapCircle },
  props: {
    filter: { type: Object, default: () => {} },
    value: { type: [String, Number, Array, Object, Date], default: '' }
  },
  computed: {
    localModel: {
      get() {
        return this.value
      },
      set(v) {
        this.$emit('update:value', v)
      }
    },
    getFilterOption() {
      return FILTER_OPTIONS[this.filter.type]
    }
  }
}
</script>

<style>
.report-filter__label {
  display: block;
  margin-bottom: 0.3rem;
}

.report-filter__control {
  width: 100%;
}

.report-filter__map {
  width: 100%;
}
</style>
